import { ReactComponent as CloseSVG } from "assets/icons/exit.svg";
import { ReactComponent as BackSVG } from "assets/icons/chevron-left.svg";
import useResponsive from 'utils/hooks/useResponsive';
import { useModal } from 'hooks';
import { Container } from './styles';
import { Div, Text, Button } from "ui";


const ModalTemplate = ({
  children,
  onBack,
  onClose,
  flowTitle,
  totalSteps,
  className,
  currentStep,
  customBackground: CustomBackground,
  hideClose,
  minHeight = '633px',
  width = '461px',
  padding = '32px',
  contentSpacing = [16, 24]
}) => {

  const { isMobile } = useResponsive()
  const { Modal } = useModal()

  const handleClose = () => {
    if (onClose) onClose()
    Modal.close()
  }

  return  (
    <Container
      className={className}
      $minHeight={minHeight}
      $width={width}
      $padding={padding}
    >
      {CustomBackground && <CustomBackground />}

      <Div
        display='flex'
        width='100%'
        alignItems='center'
        // marginBottom={isMobile ? 16 : 24}
      >
        {!!onBack && (
          <Button
            variant='tertiary'
            size={isMobile ? 'small' : 'medium'}
            onClick={onBack}
            iconLeft={BackSVG}
            iconSize={isMobile ? 16 : 20}
          />
        )}

        <Div flexGrow={1} textAlign='center'>
          <Text as='span' size={isMobile ? 'xs' : 'sm'} weight='medium'>
            {flowTitle}
          </Text>
          {' '}
          {currentStep && totalSteps && (
            <Text as='span' size={isMobile ? 'xs' : 'sm'} weight='medium' color='headline'>
              {`(${currentStep}/${totalSteps})`}
            </Text>
          )}
        </Div>

        {!hideClose && (
          <Button
          variant='tertiary'
          size={isMobile ? 'small' : 'medium'}
          onClick={handleClose}
          iconLeft={CloseSVG}
          iconSize={isMobile ? 16 : 20}
          />
        )}
      </Div>


      {/* CONTENT */}
      <Div
        position='relative'
        padding={isMobile ? '0' : '0 22px'}
        height='100%'
        flexGrow={1}
        display='flex'
        flexDirection='column'
        alignItems='center'
        marginTop={isMobile
          ? contentSpacing[0]
          : contentSpacing[1]
        }
      >
        {children}
      </Div>
    </Container>
  )

}

export default ModalTemplate